import React from 'react'
import styles from './IncomeStatements.module.css'

import PropTypes from 'prop-types'

import {
    TextField,
    Button,
    MenuItem,
    Grid
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'

class IncomeSearchForm extends React.Component {
    render() {
        return (
            <div>
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <TextField
                            type="date"
                            autoComplete="off"
                            className={styles.textFields}
                            variant="outlined"
                            size="small"
                            name="as_of_date"
                            fullWidth={true}
                            label="As of Date"
                            onChange={this.props.handleChange}
                            onKeyPress={this.props.handleKeyPress}
                            value={this.props.item.as_of_date}
                            id="incomeStatement-as_of_date"
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Autocomplete
                            value={this.props.item.branch}
                            id="branch"
                            name="branch"
                            fullWidth
                            size="small"
                            className={styles.autoCompleteField}
                            options={(this.props.branches).sort(function (a, b) {
                                if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                                if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                                return 0;
                            })}
                            getOptionLabel={(option) => option.name || ''}
                            getOptionSelected={(option, value) => option.name === value.name}
                            onChange={this.props.handleAutoComplete}
                            renderInput={(params) => (
                                <TextField {...params} name="branch" variant="outlined" label="Branch Name" />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            autoComplete="off"
                            select
                            className={styles.textFields}
                            variant="outlined"
                            size="small"
                            name="is_posted"
                            fullWidth={true}
                            label="Status"
                            onChange={this.props.handleChange}
                            value={this.props.item.is_posted || ''}
                            id="incomeStatement-classification"
                        >
                            <MenuItem value ="all"><div>All</div></MenuItem>
                            <MenuItem value="true">Posted</MenuItem>
                            <MenuItem value="false">Not Posted</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={6}>
                        <Autocomplete
                            value={this.props.item.months}
                            multiple
                            disableCloseOnSelect
                            id="months"
                            name="months"
                            fullWidth
                            size="small"
                            options={(this.props.months)}
                            getOptionLabel={(option) => option.name || ''}
                            getOptionSelected={(option, value) => option.name === value.name}
                            onChange={this.props.handleSelectChange}
                            renderInput={(params) => (
                                <TextField {...params} name="months" variant="outlined" label="Months" />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <div className={styles.actionButton}>
                            <Button variant="outlined" id="incomeStatement-search" disabled={!this.props.item.as_of_date} color="primary" onClick={() => this.props.search()} >Search</Button>
                            <Button variant="outlined" id="incomeStatement-clearSearch" color="secondary" onClick={() => this.props.clearSearch()} >Clear</Button>
                        </div>
                    </Grid>
                </Grid>


            </div>
        )
    }
}
export default IncomeSearchForm

IncomeSearchForm.propTypes = {
    handleChange: PropTypes.func,
    item: PropTypes.object,
    branches: PropTypes.array,
    search: PropTypes.func,
    clearSearch: PropTypes.func,
    handleKeyPress: PropTypes.func,
    handleAutoComplete: PropTypes.func,
    months: PropTypes.array,
    handleSelectChange: PropTypes.func
}
